import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { Notification } from '../../models/Notication';

export interface INotificationService {
    getAll(): angular.IPromise<Notification[]>;
    acknowledge(notifications: Notification[]): angular.IPromise<void>;
    delete(notificationGuid: string): angular.IPromise<void>;
}

export class NotificationService implements INotificationService {
    static $inject = ['requestService'];
    static serviceId = 'notificationService';
    
    private _url = 'notifications/';

    constructor(private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<Notification[]> {
        return this._requestService.getAtV1(this._url, undefined, true);
    }

    acknowledge(notifications: Notification[]): angular.IPromise<void> {
        const guids = notifications.map(n => n.guid);
        return this._requestService.postAtV1(`${this._url}ack`, guids, undefined, true);
    }

    delete(notificationGuid: string): angular.IPromise<void> {
        return this._requestService.postAtV1(`${this._url}delete/${notificationGuid}`);
    }
}